(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    function initMoreDropdown(overflowMenu) {
    const moreItem = overflowMenu.querySelector('[slot="more"]');
    const moreBtn = moreItem?.querySelector('button');
    if (!moreBtn) return;

    function getHeaderComponent() {
      return overflowMenu.closest('#header-component');
    }

    function getOverflowPanel() {
      return overflowMenu.shadowRoot?.querySelector('[part="overflow"]');
    }

    function open() {
      moreBtn.setAttribute('aria-expanded', 'true');
      const headerMenu = overflowMenu.closest('header-menu');
      if (headerMenu) headerMenu.dataset.overflowExpanded = 'true';
      const panel = getOverflowPanel();
      const hc = getHeaderComponent();
      if (panel && hc) {
        hc.style.setProperty('--submenu-height', `${panel.offsetHeight}px`);
      }
    }

    function close() {
      var overflowLink = overflowMenu.querySelector('[slot="overflow"] [ref="menuitem"]');
      if (overflowLink) overflowLink.setAttribute('aria-expanded', 'false');
      moreBtn.setAttribute('aria-expanded', 'false');
      const headerMenu = overflowMenu.closest('header-menu');
      if (headerMenu) headerMenu.dataset.overflowExpanded = 'false';
      const hc = getHeaderComponent();
      if (hc) hc.style.setProperty('--submenu-height', '0px');
    }

    function isOpen() {
      return moreBtn.getAttribute('aria-expanded') === 'true';
    }

    function isTablet() {
      return window.innerWidth >= 750 && window.innerWidth <= 989;
    }

    moreBtn.addEventListener('click', (e) => {
      if (!isTablet()) return;
      e.stopPropagation();
      isOpen() ? close() : open();
    });

    document.addEventListener('click', (e) => {
      if (!isTablet()) return;
      if (isOpen() && !overflowMenu.contains(e.target)) {
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (!isTablet()) return;
      if (e.key === 'Escape' && isOpen()) close();
    });
  }

  document.querySelectorAll('.overflow-menu').forEach(initMoreDropdown);

  (function () {
    function isTablet() {
      return window.innerWidth >= 750 && window.innerWidth <= 989;
    }

    function closeAllTablet() {
      document.querySelectorAll('.header-menu .menu-list__list-item[data-tablet-open]')
        .forEach(function (el) { el.removeAttribute('data-tablet-open'); });
    }

    document.querySelectorAll('.header-menu .menu-list__list-item:not([slot])').forEach(function (item) {
      var link = item.querySelector('[ref="menuitem"][aria-haspopup]');
      if (!link) return;

      link.addEventListener('click', function (e) {
        if (!isTablet()) return;
        e.preventDefault();
        if (item.hasAttribute('data-tablet-open')) {
          item.removeAttribute('data-tablet-open');
        } else {
          closeAllTablet();
          item.setAttribute('data-tablet-open', '');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!isTablet()) return;
      if (!e.target.closest('.header-menu .menu-list__list-item:not([slot])')) {
        closeAllTablet();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllTablet();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_vpl-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__vplAtcListenerAdded) return;
    window.__vplAtcListenerAdded = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vpl-atc]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      var productId = btn.dataset.productId;
      var labelEl = btn.querySelector('.vpl-cta__label');
      var originalText = labelEl ? labelEl.textContent : '';

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            btn.disabled = false;
            return;
          }

          if (labelEl) {
            labelEl.textContent =
              window.Theme && window.Theme.translations && window.Theme.translations.added
                ? window.Theme.translations.added
                : 'Added!';
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: response,
                sourceId: variantId,
                data: { source: 'vpl-cta', itemCount: 1, productId: productId },
              },
            })
          );

          setTimeout(function () {
            btn.disabled = false;
            if (labelEl) labelEl.textContent = originalText;
          }, 1500);
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["selling-plans"] && !Shopify.designMode) return;
  try {
    (() => {
    const SELECTOR = '.selling-plans-block';

    function getProductForm(block) {
      const sectionId = block.dataset.sectionId;
      return document.getElementById(`BuyButtons-ProductForm-${sectionId}`);
    }

    function getPriceText(item, useCurrency) {
      return useCurrency ? item.price_formatted_with_currency : item.price_formatted;
    }

    function getCompareText(item, useCurrency) {
      return useCurrency ? item.compare_at_price_formatted_with_currency : item.compare_at_price_formatted;
    }

    function ensureSellingPlanInput(form) {
      let input = form.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      return input;
    }

    function getCurrentVariantId(form) {
      return form.querySelector('input[name="id"]')?.value || '';
    }

    function getPlanLabel(allocation, index) {
      return allocation?.selling_plan_name || 'Subscription';
    }

    function renderOptions(block, variantData, selectedPlanId) {
      const optionsEl = block.querySelector('[data-selling-plan-options]');
      if (!optionsEl || !variantData) return;

      const useCurrency = block.dataset.useCurrency === 'true';
      const groupName = `selling_plan_option_${block.dataset.sectionId}_${block.dataset.productId}`;
      const rows = [];
      const allocations = variantData.allocations || [];
      const hasPlans = allocations.length > 0;
      const selectedAllocation =
        allocations.find((allocation) => String(allocation.selling_plan_id) === String(selectedPlanId)) || allocations[0];
      const isSubscribeSelected = hasPlans && !!selectedPlanId;

      if (hasPlans && selectedAllocation) {
        rows.push(`
          <div class="selling-plans-block__option selling-plans-block__option--subscribe" data-selected="${
            isSubscribeSelected ? 'true' : 'false'
          }">
            <label class="selling-plans-block__option-row">
              <span class="selling-plans-block__option-main">
                <input
                  type="radio"
                  name="${groupName}"
                  value="${selectedAllocation.selling_plan_id}"
                  data-plan-type="subscribe"
                  ${isSubscribeSelected ? 'checked' : ''}
                >
                <span class="selling-plans-block__option-title">Subscribe & Save ${selectedAllocation.percent_off}%</span>
              </span>
              <span class="selling-plans-block__price-inline">
                <span class="compare-at-price">${
                  useCurrency
                    ? selectedAllocation.compare_at_price_formatted_with_currency
                    : selectedAllocation.compare_at_price_formatted
                }</span>
                <span class="price">${
                  useCurrency ? selectedAllocation.price_formatted_with_currency : selectedAllocation.price_formatted
                }</span>
              </span>
            </label>
            <div class="selling-plans-block__dropdown-wrap">
              <select class="selling-plans-block__dropdown" data-selling-plan-select>
                ${allocations
                  .map((allocation, index) => {
                    const selected = String(selectedAllocation.selling_plan_id) === String(allocation.selling_plan_id);
                    return `<option value="${allocation.selling_plan_id}" ${selected ? 'selected' : ''}>${getPlanLabel(
                      allocation,
                      index
                    )}</option>`;
                  })
                  .join('')}
              </select>
            </div>
            ${block.dataset.productHandle === 'eczema-relief-kit' ? `
            <div class="selling-plans-block__subscribe-description">
              <p><strong>First Month</strong><span>&#8226; Receive <em>Soteri Skin Eczema Relief Kit</em> <strong>(40% off)</strong> to jump start skin barrier repair</span></p>
              <p><strong>Second Month or Following Order</strong><span>&#8226; Receive <em>Soteri Skin Long-Term Eczema Relief Cream</em> for just <strong>$29.99</strong> monthly or bi-monthly for long and lasting relief</span></p>
            </div>
            ` : ''}
          </div>
        `);
      }

      rows.push(`
        <div class="selling-plans-block__option selling-plans-block__option--one-time" data-selected="${
          !selectedPlanId ? 'true' : 'false'
        }">
          <label class="selling-plans-block__option-row">
            <span class="selling-plans-block__option-main">
              <input type="radio" name="${groupName}" value="" data-plan-type="one-time" ${!selectedPlanId ? 'checked' : ''}>
              <span class="selling-plans-block__option-title">One-Time Purchase</span>
            </span>
            <span class="selling-plans-block__price-inline">
              <span class="price">${useCurrency ? variantData.base_price_formatted_with_currency : variantData.base_price_formatted}</span>
            </span>
          </label>
        </div>
      `);

      optionsEl.innerHTML = rows.join('');
    }

    function ensureCompareGroup(priceEl, regularPriceLabel) {
      let compare = priceEl.querySelector('.compare-at-price');
      if (compare) return compare;

      const compareGroup = document.createElement('span');
      compareGroup.setAttribute('role', 'group');
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = `${regularPriceLabel} `;
      compare = document.createElement('span');
      compare.className = 'compare-at-price';
      compareGroup.append(hidden, compare);

      const priceSpan = priceEl.querySelector('.price');
      if (priceSpan && priceSpan.parentElement?.getAttribute('role') === 'group') {
        priceSpan.parentElement.insertAdjacentElement('afterend', compareGroup);
      } else if (priceSpan) {
        priceSpan.insertAdjacentElement('beforebegin', compareGroup);
      } else {
        priceEl.prepend(compareGroup);
      }

      return compare;
    }

    function updatePriceDisplay(block, form, map, selectedPlanId) {
      const variantId = getCurrentVariantId(form);
      if (!variantId || !map[variantId]) return;

      const variantData = map[variantId];
      const useCurrency = block.dataset.useCurrency === 'true';
      const regularPriceLabel = block.dataset.regularPriceLabel || 'Regular price';
      const priceBlocks = block
        .closest('.shopify-section, dialog, featured-product-information')
        ?.querySelectorAll(`product-price[data-product-id="${block.dataset.productId}"]`);

      if (!priceBlocks || priceBlocks.length === 0) return;

      let finalPriceCents = variantData.base_price_cents;
      let comparePriceCents = variantData.base_compare_at_price_cents;
      let finalPriceText = useCurrency ? variantData.base_price_formatted_with_currency : variantData.base_price_formatted;
      let comparePriceText = '';
      let isSellingPlanActive = false;

      if (selectedPlanId) {
        const allocation = (variantData.allocations || []).find(
          (item) => String(item.selling_plan_id) === String(selectedPlanId)
        );
        if (allocation) {
          isSellingPlanActive = true;
          finalPriceCents = allocation.price_cents;
          comparePriceCents = allocation.compare_at_price_cents;
          finalPriceText = getPriceText(allocation, useCurrency);
          comparePriceText = getCompareText(allocation, useCurrency);
        }
      }

      if (!comparePriceText && comparePriceCents > 0) {
        comparePriceText = useCurrency
          ? variantData.base_price_formatted_with_currency
          : variantData.base_price_formatted;
      }

      const showCompare = Number(comparePriceCents) > Number(finalPriceCents);

      priceBlocks.forEach((priceBlock) => {
        const priceContainer = priceBlock.querySelector('[ref="priceContainer"]') || priceBlock;
        const price = priceBlock.querySelector('.price');
        if (price) price.textContent = finalPriceText;

        const compare = ensureCompareGroup(priceBlock, regularPriceLabel);
        const priceGroup = price?.closest('[role="group"]');
        const compareGroup = compare.closest('[role="group"]');

        if (priceGroup && compareGroup) {
          priceContainer.append(priceGroup);
          priceContainer.append(compareGroup);
        }

        if (showCompare) {
          compare.textContent = comparePriceText;
          if (compareGroup) compareGroup.style.display = '';
        } else if (compareGroup) {
          compareGroup.style.display = 'none';
        }

        priceBlock.classList.toggle('selling-plan-price-active', isSellingPlanActive);
      });

      document.dispatchEvent(
        new CustomEvent('selling-plan:price-update', {
          detail: {
            productId: block.dataset.productId,
            variantId: String(variantId),
            selectedPlanId: selectedPlanId || '',
            finalPriceText,
            comparePriceText,
            showCompare,
            isSellingPlanActive,
            regularPriceLabel,
          },
        })
      );
    }

    function initBlock(block) {
      if (block.dataset.initialized === 'true') return;

      const form = getProductForm(block);
      if (!form) return;

      const jsonEl = block.querySelector('[data-selling-plan-price-map]');
      if (!jsonEl) return;

      let map = {};
      try {
        map = JSON.parse(jsonEl.textContent || '{}');
      } catch (error) {
        console.error('Failed to parse selling plan map', error);
        return;
      }

      const sellingPlanInput = ensureSellingPlanInput(form);
      const variantInput = form.querySelector('input[name="id"]');

      const sync = () => {
        const variantId = getCurrentVariantId(form);
        const variantData = map[variantId];
        if (!variantData) {
          block.style.display = 'none';
          return;
        }
        block.style.display = '';

        const validSelectedPlan =
          sellingPlanInput.value &&
          (variantData.allocations || []).some((item) => String(item.selling_plan_id) === String(sellingPlanInput.value));
        if (!validSelectedPlan) {
          const hasAllocations = variantData.allocations && variantData.allocations.length > 0;
          const userSelectedOneTime = block.dataset.userSelectedOneTime === 'true';

          if (hasAllocations && !userSelectedOneTime) {
            /* Default to first subscription plan unless user explicitly chose one-time purchase. */
            sellingPlanInput.value = String(variantData.allocations[0].selling_plan_id);
          } else {
            sellingPlanInput.value = '';
          }
        }

        renderOptions(block, variantData, sellingPlanInput.value);
        updatePriceDisplay(block, form, map, sellingPlanInput.value);

        block.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', (event) => {
            const radioValue = event.currentTarget.value || '';
            const planType = event.currentTarget.dataset.planType || '';
            if (planType === 'subscribe') {
              block.dataset.userSelectedOneTime = 'false';
              const selectedPlan = block.querySelector('[data-selling-plan-select]')?.value || radioValue;
              sellingPlanInput.value = selectedPlan || radioValue;
            } else {
              block.dataset.userSelectedOneTime = 'true';
              sellingPlanInput.value = '';
            }
            sync();
          });
        });

        const select = block.querySelector('[data-selling-plan-select]');
        if (select) {
          select.addEventListener('change', (event) => {
            const planId = event.currentTarget.value || '';
            block.dataset.userSelectedOneTime = 'false';
            sellingPlanInput.value = planId;
            const subscribeRadio = block.querySelector('input[type="radio"][data-plan-type="subscribe"]');
            if (subscribeRadio) subscribeRadio.checked = true;
            sync();
          });
        }
      };

      if (variantInput) {
        variantInput.addEventListener('change', sync);
      }
      const sectionRoot = block.closest('.shopify-section, dialog, featured-product-information');
      sectionRoot?.addEventListener('variant:update', () => setTimeout(sync, 0));

      sync();
      block.dataset.userSelectedOneTime = 'false';
      block.dataset.initialized = 'true';
    }

    const initAll = () => document.querySelectorAll(SELECTOR).forEach(initBlock);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
